import { get, writable } from 'svelte/store'

export interface FeatureFlags {
  developerMode: boolean
  demoMode: boolean
}

export const featureFlags = writable<FeatureFlags>({
  developerMode: import.meta.env.DEV,
  demoMode: false,
})

export const registerFeatureFlags = () => {
  globalThis.featureFlags = {
    enable: (key: string) => featureFlags.update(featureFlag => ({ ...featureFlag, [key]: true })),
    disable: (key: string) => featureFlags.update(featureFlag => ({ ...featureFlag, [key]: false })),
    list: () => get(featureFlags),
  }
}
